import WarningIcon from '@mui/icons-material/Warning';
import { FormControlLabel, Tooltip } from '@mui/material';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { colors, fontSize, fontWeight, TypographyStyledGlobal } from '../../../theme';
import { SwitchStyled } from '../../../theme/style';
import { ComparePeriodStyled, ComparePeriodToggleStyled } from './styled';

interface ComparePeriodToggleProps {
    isComparedToPeriod: boolean
    isComparedToGlobal?: boolean
    handleToggleCompareToPeriod: (isComparedToPeriod: boolean) => void
}

const ComparePeriodToggle: FC<ComparePeriodToggleProps> = ({ isComparedToPeriod, isComparedToGlobal = false, handleToggleCompareToPeriod }) => {
    const { t } = useTranslation('dashboard');

    return (
        <ComparePeriodStyled>
            <TypographyStyledGlobal
                color={colors.grey200}
                size={fontSize.sm}
                weight={fontWeight.regular}
            >
                {t('temporalScope.comparePeriod')}
            </TypographyStyledGlobal>
            <ComparePeriodToggleStyled>
                <Tooltip
                    componentsProps={{
                        tooltip: {
                            sx: {
                                bgcolor: colors.grey100,
                                borderRadius: '4px',
                                color: colors.grey000,
                                fontSize: fontSize.sm,
                                fontWeight: fontWeight.semiRegular,
                                maxWidth: 360,
                                padding: '6px 10px',
                                '& .MuiTooltip-arrow': { color: colors.grey100 },
                            },
                        },
                    }}
                    placement="top"
                    title={isComparedToGlobal ? (
                        <span style={{ display: 'flex', alignItems: 'flex-start', gap: '6px' }}>
                            <WarningIcon sx={{ fontSize: '16px', flexShrink: 0 }} />
                            {t('temporalScope.replaceGlobalWarning')}
                        </span>
                    ) : ''}
                    arrow
                >
                    <FormControlLabel
                        control={(
                            <SwitchStyled
                                checked={isComparedToPeriod}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleToggleCompareToPeriod(event.target.checked)}
                            />
                        )}
                        label={(
                            <TypographyStyledGlobal
                                color={colors.grey200}
                                size={fontSize.sm}
                                weight={fontWeight.regular}
                            >
                                {t('temporalScope.compare')}
                            </TypographyStyledGlobal>
                        )}
                    />
                </Tooltip>
            </ComparePeriodToggleStyled>
        </ComparePeriodStyled>
    );
};

export default ComparePeriodToggle;
